// placeholder/placeholderediting.js

import { Plugin } from '@ckeditor/ckeditor5-core';

// MODIFIED
import {
    Widget,
    toWidget,
    viewToModelPositionOutsideModelElement
} from '@ckeditor/ckeditor5-widget';

import PlaceholderCommand from './placeholdercommand';
import './theme/placeholder.css';

export default class PlaceholderEditing extends Plugin {
    static get requires() {
        return [Widget];
    }

    init() {
        console.log('PlaceholderEditing#init() got called');

        this._defineSchema();
        this._defineConverters();

        this.editor.commands.add('placeholder', new PlaceholderCommand(this.editor));

        this.editor.editing.mapper.on(
            'viewToModelPosition',
            viewToModelPositionOutsideModelElement(this.editor.model, viewElement => viewElement.hasClass('placeholder'))
        );
        let cfg = this.editor.config && this.editor.config._config && this.editor.config._config.placeHolderConfig
            ? this.editor.config._config.placeHolderConfig
            : {
                separators: ['[[', ']]'],
                types: [
                    { value: 'Directory', text: 'Directory', sample: 'Directory' },
                    { value: 'Name', text: 'Name', sample: 'Name' },
                    { value: 'Date:L', text: 'Date:L', sample: '11/21/2023' },
                    { value: 'Date:l', text: 'Date:l', sample: '11/21/2023' },
                    { value: 'Date:LL', text: 'Date:LL', sample: 'November 21, 2023' },
                    { value: 'Date:ll', text: 'Date:ll', sample: 'Nov 21, 2023' },
                    { value: 'Date:LLL', text: 'Date:LLL', sample: 'November 21, 2023 8:52 AM' },
                    { value: 'Date:lll', text: 'Date:lll', sample: 'Nov 21, 2023 8:52 AM' },
                    { value: 'Date:LLLL', text: 'Date:LLLL', sample: 'Tuesday, November 21, 2023 8:52 AM' },
                    { value: 'Date:llll', text: 'Date:llll', sample: 'Tue, Nov 21, 2023 8:55 AM' },
                ]
            };
        this.editor.config.define('placeholderConfig', cfg);
    }

    _defineSchema() {
        const schema = this.editor.model.schema;

        schema.register('placeholder', {
            // Behaves like a self-contained inline object (e.g. an inline image)
            // allowed in places where $text is allowed (e.g. in paragraphs).
            // The inline widget can have the same attributes as text (for example linkHref, bold).
            inheritAllFrom: '$inlineObject',

            // The placeholder can have many types, like date, name, surname, etc:
            allowAttributes: ['name']
        });
    }

    _defineConverters() {
        const conversion = this.editor.conversion;
        let theEditor = this.editor;
        conversion.for('upcast').elementToElement({
            view: {
                name: 'span',
                classes: ['placeholder']
            },
            model: (viewElement, { writer: modelWriter }) => {
                // Extract the "name" from "{name}".
                const name = viewElement.getChild(0).data.slice(1, -1);

                return modelWriter.createElement('placeholder', { name });
            }
        });

        conversion.for('editingDowncast').elementToElement({
            model: 'placeholder',
            view: (modelItem, { writer: viewWriter }) => {
                const widgetElement = createPlaceholderView(modelItem, viewWriter);

                // Enable widget handling on a placeholder element inside the editing view.
                return toWidget(widgetElement, viewWriter);
            }
        });

        conversion.for('dataDowncast').elementToElement({
            model: 'placeholder',
            view: (modelItem, { writer: viewWriter }) => createPlaceholderView(modelItem, viewWriter)
        });

        // Helper method for both downcast converters.
        function createPlaceholderView(modelItem, viewWriter) {
            const name = modelItem.getAttribute('name');

            const placeholderView = viewWriter.createContainerElement('span', {
                class: 'placeholder'
            });

            // Insert the placeholder name (as a text).
            let separators = theEditor?.config?.get('placeholderConfig')?.separators || ['[[', ']]'];
            const innerText = viewWriter.createText(separators[0] + name + separators[1]);
            viewWriter.insert(viewWriter.createPositionAt(placeholderView, 0), innerText);

            return placeholderView;
        }
    }
}
